type Input = {
    mdfId: string;
    rmdfMdfNumber: string;
    coTeID: string;
    coName: string;
    shipmentNumber: string;
    shipmentDate: string;
    invoiceDate: string;
    orderNumber: string;
    productCategory: string;
    productDetail: string;
    weightInKgs: string;
    organizationName: string;
    teId: string;
    address: string;
    state: string;
    country: string;
    rawMaterialDetails: {
      rawMaterialCode?: string;
      rawMaterialPercentage?: string;
    }[];
  };
  
  type Output = {
    mdfId: string;
    rmdfMdfNumber: string;
    coTeID: string;
    coName: string;
    shipmentNumber: string;
    shipmentDate: string;
    invoiceDate: string;
    orderNumber: string;
    productCategory: string;
    productDetail: string;
    weightInKgs: string;
    sourceRawMaterialSupplier: {
      organizationName: string;
      teId: string;
      address: string;
      state: string;
      country: string;
    };
    rawMaterialDetails: {
      rawMaterialCode: string;
      rawMaterialPercentage: string;
    }[];
  };
  
 export const mapFormToPayload = (data: Input): Output => {
    return {
      mdfId: data.rmdfMdfNumber, // fixed value as per your example
      rmdfMdfNumber: data.rmdfMdfNumber,
      coTeID: data.coTeID,
      coName: data.coName,
      shipmentNumber: data.shipmentNumber,
      shipmentDate: data.shipmentDate,
      invoiceDate: data.invoiceDate,
      orderNumber: data.orderNumber,
      productCategory: data.productCategory,
      productDetail: data.productDetail,
      weightInKgs: data.weightInKgs,
      sourceRawMaterialSupplier: {
        organizationName: data.organizationName,
        teId: data.teId,
        address: data.address,
        state: data.state,
        country: data.country,
      },
      rawMaterialDetails: data.rawMaterialDetails.map((item) => ({
        rawMaterialCode: item.rawMaterialCode || "",
        rawMaterialPercentage: item.rawMaterialPercentage || "",
      })),
    };
  };
  